import { createContext } from 'react';
import { decorate, observable, action, toJS, computed } from 'mobx';

import * as fn from '../utilities/_functions';
import api from '../api';

export class CommunicationTemplateCreate {
    id = null;
    types = [];
    data = {
        name: null,
        templateType: null,
        communicationTypes: [],
    };
    selectedCategory = null;
    selectedSubType = null;
    isReady = false;
    isSaving = false;
    hasUnsavedChanges = false;

    cancelCommunicationTemplateTypes = null;
    cancelCommunicationTemplateCreate = null;

    initialize = (category, subType) => {
        const that = this;

        that.clear();
        that.selectedCategory = category;
        that.selectedSubType = subType;

        return new Promise((resolve, reject) => {
            api.CommunicationTemplateTypes.all((c) => { that.cancelCommunicationTemplateTypes = c })
                .then(({ data }) => {
                    that.types = data && data.length > 0 ? data : [];
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    that.isReady = true;
                })
        })
    }

    save = (notify) => {
        const that = this;

        if (!!notify) {
            this.isSaving = true;
        }

        return new Promise((resolve, reject) => {
            let option = toJS(that.data);

            api.CommunicationTemplates.create(
                option,
                (c) => { that.cancelCommunicationTemplateCreate = c }
            )
                .then(({ data }) => {
                    that.id = data.id;
                    that.hasUnsavedChanges = false;
                    option.id = data.id;
                    resolve(option);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    that.isSaving = false;
                })
        })
    }

    get templateTypes() {
        const that = this;

        if (that.types && that.types.length > 0 && that.selectedCategory && that.selectedSubType) {
            const category = that.types.find(t => t.category === that.selectedCategory);

            if (category) {
                const subType = category.subTypes.find(t => t.subType === that.selectedSubType);

                if (subType) {
                    return subType.types && subType.types.length > 0 ? subType.types : [];
                }
            }
        }

        return [];
    }

    clear = () => {
        this.id = null;
        this.types = [];
        this.data.name = null;
        this.data.templateType = null;
        this.data.communicationTypes = [];
        this.selectedCategory = null;
        this.selectedSubType = null;
        this.hasUnsavedChanges = false;

        if (fn.isFunction(this.cancelCommunicationTemplateTypes)) {
            this.cancelCommunicationTemplateTypes();
            this.cancelCommunicationTemplateTypes = null;
        }

        if (fn.isFunction(this.cancelCommunicationTemplateCreate)) {
            this.cancelCommunicationTemplateCreate();
            this.cancelCommunicationTemplateCreate = null;
        }
    }
}

decorate(CommunicationTemplateCreate, {
    id: observable,
    types: observable,
    data: observable.deep,
    hasUnsavedChanges: observable,
    selectedCategory: observable,
    selectedSubType: observable,
    isReady: observable,
    isSaving: observable,
    initialize: action,
    save: action,
    clear: action,
    templateTypes: computed,
})

export default createContext(new CommunicationTemplateCreate());